var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("flex-row", { staticClass: "flex--button-below-label" }, [
        _c(
          "div",
          { staticClass: "col items-selector-container-narrow" },
          [
            _c("items-typeahead", {
              attrs: {
                id:
                  "search-sku_" +
                  (_vm.parent.id || _vm.parent.idx) +
                  "-new-item",
                name: "search-sku_" + _vm.parent.id + "-new-item",
                value: _vm.selectedItem.sku,
                label: _vm.$t("items.labels.sku"),
                "preloaded-options": _vm.items,
                placeholder: "",
                spacing: "xs",
                "allow-empty": false,
                validation: { name: _vm.$t("items.labels.sku") }
              },
              on: {
                input: _vm.onItemSelected,
                "skus-loaded": function(loadedOptions) {
                  return _vm.saveSearchResult(loadedOptions)
                }
              }
            })
          ],
          1
        ),
        !_vm.hideInputQty
          ? _c(
              "div",
              { staticClass: "col col--width-qty" },
              [
                _c("form-input", {
                  attrs: {
                    id:
                      "search-sku_" +
                      (_vm.parent.id || _vm.parent.idx) +
                      "-new-item-quantity",
                    name: "search-sku_" + _vm.parent.id + "-new-item-quantity",
                    label: _vm.$t("items.labels.quantity"),
                    spacing: "xs",
                    type: "number",
                    step: "1",
                    min: "1",
                    rules: "min_value:1|max:9",
                    validation: { name: _vm.$t("items.labels.quantity") }
                  },
                  model: {
                    value: _vm.selectedItem.quantity,
                    callback: function($$v) {
                      _vm.$set(_vm.selectedItem, "quantity", $$v)
                    },
                    expression: "selectedItem.quantity"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("flex-row", { staticClass: "selected-item-info" }, [
        _c("div", { staticClass: "item-info-section col" }, [
          _c("label", { staticClass: "info-section-label" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("consumerOrders.labels.skuDescription")) +
                "\n            "
            )
          ]),
          _c("div", { staticClass: "info-section-text" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.selectedItem.description) +
                "\n            "
            )
          ])
        ]),
        !_vm.hideAvailableQty
          ? _c("div", { staticClass: "item-info-section col col--width-qty" }, [
              _c("label", { staticClass: "info-section-label" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("consumerOrders.labels.totalQty")) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "info-section-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getAvailableCount()) +
                    "\n            "
                )
              ])
            ])
          : _vm._e(),
        _vm.isSelectItemLotTacked === false ||
        _vm.isShowLotTrackedItem === false
          ? _c("div", { staticClass: "item-info-section col col--width-qty" }, [
              _c(
                "div",
                { staticClass: "info-section-button with-button" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        primary: "",
                        disabled: _vm.isDisableInputQuantity
                      },
                      on: {
                        click: function($event) {
                          return _vm.addItem()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.inputQtyText) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm.isSelectItemLotTacked === true &&
      _vm.isShowLotTrackedItem === true &&
      _vm.selectedItem.availableQty > 0
        ? _c("flex-row", { staticClass: "flex--button-below-label" }, [
            _c(
              "div",
              { staticClass: "col items-selector-container-narrow" },
              [
                _c("form-select", {
                  attrs: {
                    id: "item-lotTrack-number",
                    options: _vm.selectedItem.displayLotNumbers,
                    name: "item-lotTrack-number",
                    searchable: false,
                    "option-label": "lotNumber",
                    "value-field": "lotNumber",
                    "track-by": "lotNumber",
                    label: _vm.$t("items.labels.lotNumber")
                  },
                  on: { input: _vm.onLotTrackItemChange },
                  model: {
                    value: _vm.selectedItem.lotNumber,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.selectedItem,
                        "lotNumber",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "selectedItem.lotNumber"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col col--width-qty" },
              [
                _c("form-input", {
                  attrs: {
                    id:
                      "search-sku_" +
                      (_vm.parent.id || _vm.parent.idx) +
                      "-new-item-quantity",
                    name: "search-sku_" + _vm.parent.id + "-new-item-quantity",
                    label: _vm.$t("items.labels.availableQty"),
                    disabled: true,
                    validation: { name: _vm.$t("items.labels.quantity") }
                  },
                  model: {
                    value: _vm.selectedItem.availableLotQty,
                    callback: function($$v) {
                      _vm.$set(_vm.selectedItem, "availableLotQty", $$v)
                    },
                    expression: "selectedItem.availableLotQty"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.isSelectItemLotTacked === true &&
      _vm.isShowLotTrackedItem === true &&
      _vm.selectedItem.availableQty > 0
        ? _c("flex-row", { staticClass: "selected-item-info" }, [
            _c(
              "div",
              { staticClass: "item-info-section col" },
              [
                _vm.selectedItem.isExpirationTracked
                  ? _c("form-select", {
                      attrs: {
                        id: "item-lotTrack-expirationDate",
                        options: _vm.selectedExpirationDates,
                        name: "item-lotTrack-expirationDate",
                        searchable: false,
                        "option-label": "expirationDate",
                        "value-field": "expirationDate",
                        "track-by": "expirationDate",
                        label: _vm.$t("items.labels.expirationdate")
                      },
                      on: { input: _vm.onLotTrackItemExpirationDateChange },
                      model: {
                        value: _vm.selectedItem.expirationDate,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.selectedItem,
                            "expirationDate",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "selectedItem.expirationDate"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "info-two-section-button with-button" },
              [
                _c(
                  "base-button",
                  {
                    style: {
                      margin: _vm.selectedItem.isExpirationTracked
                        ? "47px 15px"
                        : "0px 18px 5px"
                    },
                    attrs: {
                      primary: "",
                      disabled: _vm.isDisableInputQuantity
                    },
                    on: {
                      click: function($event) {
                        return _vm.addItem()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.inputQtyText) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.isLotTrackExpandSelectDisplay === true &&
      _vm.isShowLotTrackedItem === false &&
      _vm.isSelectItemLotTacked === true &&
      _vm.selectedItem.availableQty > 0
        ? _c("flex-row", { staticClass: "flex--button-below-label" }, [
            _c("div", { staticClass: "col items-selector-container-narrow" }, [
              _c(
                "div",
                { staticClass: "info-section-button with-button" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { id: "add-lotTracked-line", "as-link": "" },
                      on: { click: _vm.addLotTrackedItem }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            slot: "iconLeft",
                            width: "20",
                            height: "20"
                          },
                          slot: "iconLeft"
                        },
                        [_c("use", { attrs: { "xlink:href": "#plus-round" } })]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("items.labels.lotnumberExpandSelectLot")
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _c("flex-row", { staticClass: "selected-item-info" }, [
        _vm.isVisibleRecordSerialNumber && _vm.selectedItem.isSerialTracked
          ? _c(
              "div",
              { staticClass: "item-info-section col radio-check" },
              [
                _c("base-radio-check", {
                  attrs: {
                    id: "selected-is-record-serial-number",
                    value: _vm.selectedItem.isRecordSerialNumber,
                    type: "checkbox",
                    label: _vm.$t("items.labels.requiredSerialNumberCapture"),
                    "tooltip-text": _vm.$t(
                      "items.labels.requiredSerialNumberCaptureToolTip"
                    )
                  },
                  on: { input: _vm.onIsRecordSerialNumber }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }